window.moment = require('moment');
window.Pikaday = require ('pikaday');

window.app = {

    showError: function(title, message) {
        swal({
            title: title,
            text: message,
            buttonsStyling: false,
            confirmButtonClass: "btn btn-danger",
            type: "danger"
        }).catch(swal.noop)
    },

    showConfirm: function(title, message, button, func) {

        swal({
            title: title,
            text: message,
            type: 'warning',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-success',
            cancelButtonClass: 'btn btn-danger',
            confirmButtonText: button,
            buttonsStyling: false
        }).then(function() {
            func();
        }).catch(swal.noop)
    },

};
